import {
  activeTravelPassesProfileSelector,
  historyTravelPassesProfileSelector,
} from '@/features/profile/profileSelectors';
import BookingNoItems from '@/routes/account/layout/BookingNoItems';
import { useSelector } from '@/store/utils';
import type { ProfileBookingTimeType } from '@/types/profile';
import type { FC } from 'react';

interface TravelPassesListProps {
  timeType: ProfileBookingTimeType;
}

const TravelPassesList: FC<TravelPassesListProps> = ({ timeType }) => {
  const travelPasses = useSelector(
    timeType === 'active'
      ? activeTravelPassesProfileSelector
      : historyTravelPassesProfileSelector
  );

  if (!travelPasses?.length) {
    return <BookingNoItems bookingType="travelPasses" timeType={timeType} />;
  }

  return <div>{timeType} travel passes</div>;
};

export default TravelPassesList;
